export const isPathActive = (pathname: string, href: string) =>
  pathname === href || pathname.startsWith(`${href}/`)
